import React from 'react';
import PropTypes from 'prop-types';
import { Box, IconButton } from '@material-ui/core';
import CloseIcon from '@mui/icons-material/Close';
import { ShieldCheckIcon, Typography } from '@orijinworks/frontend-commons';
import { useEditorChipStyles } from './EditorChip.styles';

/**
 * Chip displaying a selected plan editor. Creator chips are non-removable.
 */
export const EditorChip = ({ editor, onRemove }) => {
  const classes = useEditorChipStyles();
  const canRemove = !editor.isCreator && typeof onRemove === 'function';

  return (
    <Box className={classes.root}>
      <Box className={classes.content}>
        <ShieldCheckIcon size={16} fill="currentColor" />
        <Typography variant="body2" className={classes.name}>
          {editor.name}
        </Typography>
      </Box>
      {canRemove ? (
        <IconButton
          className={classes.removeButton}
          size="small"
          aria-label={`Remove ${editor.name}`}
          onClick={() => onRemove(editor)}
        >
          <CloseIcon fontSize="inherit" />
        </IconButton>
      ) : null}
    </Box>
  );
};

EditorChip.propTypes = {
  editor: PropTypes.shape({
    personId: PropTypes.number,
    name: PropTypes.string,
    isCreator: PropTypes.bool,
  }).isRequired,
  onRemove: PropTypes.func,
};

EditorChip.defaultProps = {
  onRemove: undefined,
};

export default EditorChip;
